import setItemLocalStorageUtil from 'utils/local-storage/set-item'
import { SQUAD_LOCAL_STORAGE_KEY } from 'modules/squad/constants'

export default function setShouldScrollToReferAFriendAfterSignInUtil () {
  setItemLocalStorageUtil(SQUAD_LOCAL_STORAGE_KEY.SQUAD_SHOULD_SCROLL_TO_REFER_A_FRIEND_AFTER_SIGN_IN, 'true')
}
